/* unplugin-vue-components disabled */
import {FiltersCheckgroups, FiltersDropdown, Filters} from './filters-elements'

export default {
  components: {FiltersCheckgroups, FiltersDropdown, Filters},
  mixins: [ModelValue(Array)],
  props: {
    title: {type: String, default: ''},
    items: {type: Array, default: () => []},
    width: {type: String, default: '24rem'}
  }
}
